import {
  Inject,
  LOCALE_ID,
  Pipe,
  PipeTransform
} from '@angular/core';
import { DatePipe } from '@angular/common';
import {
  differenceInCalendarDays
} from 'date-fns/esm';

import { dateFormat } from './p1-date-format.constant';


@Pipe({
  name: 'p1DateFormat'
})
export class P1DateFormatPipe implements PipeTransform {
  datePipe: DatePipe;

  constructor(@Inject(LOCALE_ID) private _locale: string) {
    this.datePipe = new DatePipe(this._locale);
  }

  /**
   * Transforms the given datestring into the date format thats defined for the location
   * If the given datestring refers to today or yesterday, "today"/"yesterday" are shown instead of the date
   *
   * @param value
   */
  transform(value: string | number) {
    const diffInDays = differenceInCalendarDays(new Date(), new Date(value));

    if (diffInDays > 1) {
      value = this.datePipe.transform(value, 'short');
      return value;
    } else {
      return this.convertToNiceDate(diffInDays, this.datePipe.transform(value, 'shortTime'));
    }
  }

  /**
   * Returns a date formatted with "Today" or "Yesterday" depending on the given diffInDays
   *
   * @param diffInDays
   * @param timeOfDay
   */
  private convertToNiceDate(diffInDays: number, timeOfDay): string {
    return diffInDays === 0 && dateFormat.today + ', ' + timeOfDay ||
           diffInDays === 1 && dateFormat.yesterday + ', ' + timeOfDay;
  }

}

